import React, { useRef } from 'react';

import { Card, CardContent, CardHeader, CardTitle, RadarChart } from '@mesh.ai/rabbit';
import { CompetencySpiderChart } from 'Deer/pages/MyData/Overview/types/FeedbackMyOverview';

import noInsights from 'assets/assetsV1/illustrations/deerIllustrations/noInsights.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

export const LifecycleSpiderChart = ({
  iSpiderChartLoading,
  spiderChartData,
}: {
  iSpiderChartLoading: boolean;
  spiderChartData: CompetencySpiderChart;
}) => {
  const ref = useRef();
  const graphNodes = spiderChartData?.competencyGraphData?.map((competency) => ({
    id: competency.employeeId ? String(competency.employeeId) : 'COMPANY',
    name: 'Revenue generation',
  }));

  const graphSeries = spiderChartData?.competencyGraphData?.map((item) => ({
    data: item.scores
      .map((score) => score.score) // Extracting scores
      .filter((score) => score !== 0), // Filtering non-zero scores
    id: item.employeeId ? String(item.employeeId) : 'COMPANY',
  }));

  // filter non-zero competencies
  const filteredCompetencies = spiderChartData?.competencyDetails?.filter((comp) => {
    const score = spiderChartData?.competencyGraphData[0]?.scores?.find((sc) => sc.competencyId === comp.competencyId);
    return score.score !== 0;
  });

  const maxRating = spiderChartData?.maxRating;

  // extract out the names of the competencies
  const competencyNames = filteredCompetencies?.map((value) => value.competencyName);

  if (iSpiderChartLoading) {
    return <SkeletonLoader />;
  }

  if (spiderChartData?.competencyDetails?.length >= 15) {
    return (
      <Card
        style={{
          minHeight: '329px',
          height: '100%',
        }}
      >
        <CardContent>
          <EmptyScreen
            illustrationSrc={noInsights}
            heading="Too many data points to show"
            isSmallTextSize
            description="We are unable to show this graph because you have more than 15 competencies"
            smallTextMargin="0px"
          />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card style={{ height: '100%', padding: '12px' }}>
      <CardHeader>
        <CardTitle style={{ color: '#666', fontSize: '12px', fontWeight: 'bold' }}>Expected competencies</CardTitle>
      </CardHeader>
      <CardContent style={{ height: 'calc(100% - 32px)' }}>
        <div
          className="rabbit-ds"
          style={{
            height: '100%',
            width: '100%',
          }}
        >
          {/* @ts-expect-error props */}
          <RadarChart
            ref={ref}
            nodes={graphNodes}
            yAxisDomain={[0, maxRating ?? 100]}
            series={graphSeries}
            tooltipTitle="Competency score"
            xAxisLabel="Competencies"
            xAxisValues={competencyNames}
          />
        </div>
      </CardContent>
    </Card>
  );
};
